import { render, staticRenderFns } from "./LogsManagement.vue?vue&type=template&id=0df56ecf&scoped=true"
import script from "./LogsManagement.vue?vue&type=script&lang=js"
export * from "./LogsManagement.vue?vue&type=script&lang=js"
import style0 from "./LogsManagement.vue?vue&type=style&index=0&id=0df56ecf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df56ecf",
  null
  
)

export default component.exports